import styled from "styled-components";
import Card from "../../../../components/Card";
import * as color from "../../../../styles/colors";
import { shade } from "polished";

export const Container = styled(Card)`
  margin-top: 28px;

  .view-uploads-button {
    background: transparent;
    border: none;
    color: ${color.orange};

    &:hover {
      color: ${shade(0.2, color.orange)};
    }
  }

  .badge {
    display: flex;
    align-self: flex-end;
  }

  .section-title-badge {
    padding: 5px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-top: 50px;
  }
`;

export const SectionTitle = styled.p`
  font-size: 16px !important;
  font-weight: bold;
  margin-right: 15px;
  /* margin: 14px 0 14px; */
`;
